/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { View, Text } from '@az/starc-ui';
import cx from 'classnames';
import { type ContentStackImageContentBackground } from '../../interface';
import styles from './CMSImageContentBackground.module.scss';
import { CMSImage } from '../CMSImage/CMSImage';
import { CMSButton } from '../CMSButton/CMSButton';
import { CMSHeadline } from '../CMSHeadline/CMSHeadline';
import { useCMSRichTextModal } from '../../hooks/useCMSRichTextModal';

type Props = {
  content: ContentStackImageContentBackground;
};

export const CMSImageContentBackground = ({ content }: Props) => {
  const {
    background_color: backgroundColor,
    image,
    heading,
    button,
    image_direction: direction,
  } = content;
  const customStyles: React.CSSProperties = {
    '--background-color': backgroundColor?.hex,
  } as React.CSSProperties;
  const { processedHTML, handleClick, ModalComponents } = useCMSRichTextModal(content.description);
  return (
    <div
      style={backgroundColor ? customStyles : undefined}
      className={cx(styles.container, direction === 'Right' && styles.imageOnRightSide)}
    >
      {image && (
        <View className={styles.imgContainer}>
          <CMSImage image={image} />
          <View className={styles.imgBackground} />
        </View>
      )}
      <View className={styles.contentContainer}>
        <CMSHeadline className={styles.title} nested>
          {heading}
        </CMSHeadline>
        <Text
          className={styles.description}
          attributes={{
            dangerouslySetInnerHTML: { __html: processedHTML },
            onClick: handleClick,
          }}
        >
          {null}
        </Text>
        <ModalComponents />
        {button?.link?.title && (
          <View className={styles.buttonsContainer}>
            <CMSButton options={button} />
          </View>
        )}
      </View>
    </div>
  );
};
